import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=236eca21&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236eca21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('236eca21')) {
      api.createRecord('236eca21', component.options)
    } else {
      api.reload('236eca21', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=236eca21&scoped=true", function () {
      api.rerender('236eca21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/practitionerIntern/components/Documents/Index.vue"
export default component.exports